import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatCheckboxModule,
  MatDialogModule,
  MatIconModule,
  MatSnackBarModule
} from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { FcYearMonthInputModule } from '../fc-input/search-one/fc-year-month-input/fc-year-month-input.module';
import { ExportDialogImrComponent } from './export-dialog-imr.component';


@NgModule({
  declarations: [
    ExportDialogImrComponent
  ],
  entryComponents: [
    ExportDialogImrComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSnackBarModule,
    FcYearMonthInputModule
  ],
  exports: [
    ExportDialogImrComponent
  ],
  providers: [
  ]
})
export class ExportDialogImrModule { }
